import React, { createContext } from "react";

import cx from "classnames";
import _ from "lodash";
import buildUrl from "build-url-ts";

import { Link, Outlet } from "react-router-dom";
import ReportFiltersView from "./components/filters";

import {
  generateQueryParams,
  parseQueryParams,
  prepareRequest,
  daysDifference
} from "../../services/report.service"

import styles from "./reports.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import isEqual from "is-equal";
import numeral from "numeral";
import { localizedStrings } from '../../../localization';
import DOMPurify from "dompurify";
import userRoleService from "src/services/userRoles.service"; 

export const ReportContext = createContext();
class ReportsView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: {
        reportDate: parseQueryParams(this.props.location.query),
        filters: [],
        userType: 'all',
        sortBy: 'views',
        interval: _.get(this.props, "location.query.interval", "day")
      },
      showFilter: false,
      filters: this.props.filters,
      saveFilterView: false,
      filterName: "",
      filterId: null
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleTimeLineChange = this.handleTimeLineChange.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
    this.localizedDiscovery = this.localizedReport.tabs.discovery;
    this.localizedEngagemenet = this.localizedReport.tabs.engagement;
    this.localizedPerformance = this.localizedReport.tabs.performance;
  }

  componentDidMount() {
    this.props.trackAdoptionMetricsForReportsViewedEvent();
    this.props.trackAdoptionMetricsForReportScreenView();
    
    this.setState(
      {
        filter: {
          ...this.state.filter,
          reportDate: parseQueryParams(this.props.location.query),
          interval: _.get(this.props, "location.query.interval", "day")
        },
      },
      () => {
        const url = this.generateReportUrl(
          this.props.location.pathname,
          this.state.filter.reportDate,
          this.state.filterId,
          _.get(this.state, "filter.interval")
        );
        this.props.navigate(url);
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.filters, this.props.filters)) {
      this.setState({
        filters: nextProps.filters,
        interval: _.get(nextProps, "location.query.interval", "day")
      });
    }

    this.setState({
      interval: _.get(nextProps, "location.query.interval")
    });

    if (!nextProps.location.query.dateRange && (nextProps.location.query.dateRange !== this.props.location.query.dateRange)) {
      var url = this.generateReportUrl(
        "/reports/discovery",
        this.state.filter.reportDate,
        this.state.filterId,
        _.get(this.props, "location.query.interval")
      )
      this.props.navigate(url);
    }
  }

  generateReportUrl(url, reportDate, filterId, interval) {
    var updatedUrl = url;
    if (url === "/reports") {
      updatedUrl = "/reports/discovery"
    }
    const queryParams = generateQueryParams(reportDate, filterId, interval);

    const query = {
      ...this.props.location.query,
      ...queryParams,
    };
    const updated = buildUrl(updatedUrl, {
      queryParams: query,
    });

    return updated;
  }

  handleFilterChange(filter) {
    const reportDate = _.get(filter, "reportDate");
    var daysBetween = -1;
    if (reportDate) {
      daysBetween = daysDifference(_.get(reportDate, "startDate"), _.get(reportDate, "endDate"));
    }
    this.setState(
      {
        filter: {
          ...this.state.filter,
          ...filter,
          interval: daysBetween > 365 ? "week" : "day"
        },
      },
      () => {
        const url = this.generateReportUrl(
          this.props.location.pathname,
          this.state.filter.reportDate,
          this.state.filterId,
          _.get(this.state, "filter.interval")
        );
        this.props.navigate(url);
      }
    );
  }

  handleTimeLineChange(value) {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          interval: value
        },
      },
      () => {
        const url = this.generateReportUrl(
          this.props.location.pathname,
          this.state.filter.reportDate,
          this.state.filterId,
          _.get(this.state, "filter.interval")
        );
        this.props.navigate(url);
      }
    );
  }

  render() {
    const contextObj = {
      filter: this.state.filter
    }
    const pathName = _.get(this.props, "location.pathname");
    return (
      <div className={cx(styles.reports, "reports_page")}>
        <div className={styles.inner}>
          <h1 className={styles.pageTitle}>{this.localizedReport.title}</h1>
          <p className={styles.subTitle}>
            {this.localizedReport.sub_text}
          </p>

          <ReportSummary
            request={this.state.filter}
            value={this.props.reportSummary}
            fetchSummary = {(nudgesType) =>{
              this.props.fetchReportSummaryNudges(nudgesType);
            }}
          />

          <ReportFiltersView
            value={this.state.filter}
            onChange={this.handleFilterChange}
            handleTimeLineChange={this.handleTimeLineChange}
          />

          <div className={styles.tabsContainer}>
            <Link
              to={this.generateReportUrl(
                "/reports/discovery",
                this.state.filter.reportDate,
                this.state.filterId,
                _.get(this.state, "filter.interval")
              )}
              className={cx(styles.tab, {
                [styles.active]: pathName === "/reports/discovery"
              })}
            >
              <i className={cx(styles.icon, "paperflite-discover")}></i>
              <div className={styles.content}>
                <h5>{this.localizedDiscovery.title}</h5>
                <p>{this.localizedDiscovery.sub_text}</p>
                <div className={styles.border} />
              </div>
            </Link>
            {userRoleService.canShare() &&
              <Link
                to={this.generateReportUrl(
                  "/reports/engagement",
                  this.state.filter.reportDate,
                  this.state.filterId,
                  _.get(this.state, "filter.interval")
                )}
                className={cx(styles.tab, {
                  [styles.active]: pathName === "/reports/engagement"
                })}
              >
                <i className={cx(styles.icon, "paperflite-collaborate")}></i>
                <div className={styles.content}>
                  <h5>{this.localizedEngagemenet.title}</h5>
                  <p>{this.localizedEngagemenet.sub_text}</p>
                  <div className={styles.border} />
                </div>
              </Link>
            } 
            {userRoleService.canShare() &&
              <Link
                to={this.generateReportUrl(
                  "/reports/performance",
                  this.state.filter.reportDate,
                  this.state.filterId,
                  _.get(this.state, "filter.interval")
                )}
                className={cx(styles.tab, {
                  [styles.active]: pathName === "/reports/performance"
                })}
              >
                <i className={cx(styles.icon, "paperflite-performance")}></i>
                <div className={styles.content}>
                  <h5>{this.localizedPerformance.title}</h5>
                  <p>{this.localizedPerformance.sub_text}</p>
                  <div className={styles.border} />
                </div>
              </Link>
            }
          </div>
          <ReportContext.Provider value={contextObj}>
            <Outlet />
          </ReportContext.Provider>
        </div>
      </div>
    );
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

class ReportSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
    };

    this.fetchSummary = this.fetchSummary.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
    this.localizedDiscovery = this.localizedReport.tabs.discovery;
    this.localizedEngagemenet = this.localizedReport.tabs.engagement;
    this.localizedPerformance = this.localizedReport.tabs.performance;
  }

  componentDidMount() {
    this.loadReport(this.props.request);
  }

  loadReport(request) {
    if (!request) {
      return;
    }

    const processedRequest = prepareRequest(
      request,
      this.props.supportedEntities
    );
    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState(
        {
          request: processedRequest,
        },
        () => {
          this.fetchSummary();    
        }
      );
    }
  }

  fetchSummary(){
    const summaryTypes = ["assets", "activeUser", "session", "share", "contact", "deal", "lead"];
    summaryTypes.forEach((type) => {
      this.props.fetchSummary(type);
    });
  }
  
  render() {
    const dealValue = numeral(_.get(this.props.value, "deal.dealValue", 0)).format(
      "($0.00a)"
    );
    return (
      <div className={styles.metricsContainer}>
        <Metrics
          icon=""
          title={this.localizedReport.cards.assets}
          value={_.get(this.props.value, "assets.assets", "-")}
        />
        <Metrics
          icon=""
          title={this.localizedReport.cards.active_users}
          value={_.get(this.props.value, "activeUser.activeUsers", "-")}
        />
        <Metrics
          icon=""
          title={this.localizedReport.cards.asset_views}
          value={_.get(this.props.value, "session.teamViews", "-")}
        />

        {userRoleService.canShare() &&
          <span className={styles.shareMetricsContainer}>
            <Metrics
              icon=""
              title={this.localizedReport.cards.conversations}
              value={_.get(this.props.value, "share.shares", "-")}
            />
            <Metrics
              icon=""
              title={this.localizedReport.cards.engaged_users}
              value={_.get(this.props.value, "contact.engagedContacts", "-")}
            />
            <Metrics
              icon=""
              title={this.localizedReport.cards.leads}
              value={_.get(this.props.value, "lead.leads", "-")}
            />
            <Metrics
              icon=""
              title={this.localizedReport.cards.deals}
              value={_.get(this.props.value, "deal.deals", "-")}
            />
            <Metrics
              icon=""
              title={this.localizedReport.cards.sales}
              value={dealValue}
            />
          </span>
        }
      </div>
    );
  }
}

class Metrics extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    return (
      <div className={cx(styles.metrics, this.props.className)}>
        <i className={cx(styles.icon, this.props.icon)} />
        <span className={styles.title}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.title) }}></span>
        <h3 className={styles.value}>{this.props.value}</h3>
      </div>
    );
  }
}



export default ReportsView;
